import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_URL } from "../constants";
import axiosInstance from "../hooks/useAxios";
import { useSiteData } from "../hooks/provider/SiteDataProvider";

const UPDATED_ON_KEY = "siteDataUpdatedOn";

const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp && payload.exp > now;
  } catch (e) {
    return false;
  }
};

const SiteInfo = () => {
  const { siteData, updateSiteData } = useSiteData();
  const location = useLocation(); // ✅ get current route

  useEffect(() => {
    const fetchSiteData = async () => {
      const currentPath = location.pathname;

      // ✅ Skip request if route starts with /admin or /vendor (except /vendor/register)
      if ((currentPath.startsWith("/admin") || currentPath.startsWith("/vendor")) && !currentPath.startsWith("/vendor/register")) {
        return;
      }

      const lastUpdatedOn = localStorage.getItem(UPDATED_ON_KEY) || "0";
      const token = localStorage.getItem("userAuthToken");
      const deviceId = siteData?.deviceId;

      const headers = {
        "Content-Type": "application/json",
      };

      if (token && isTokenValid(token)) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      try {
        const res = await axiosInstance.post('/f91e-521e0e', { lastUpdatedOn, deviceId });
        const result = res?.data || {};

        if (result.updated_on !== lastUpdatedOn) {
          localStorage.setItem(UPDATED_ON_KEY, result.updated_on);
          updateSiteData(result);
        }
      } catch (error) {
        console.error("Error fetching site data:", error.message);
      }
    };

    fetchSiteData();
  }, [location.pathname, siteData?.deviceId]);

  return null;
};

export default SiteInfo;
